import { render, staticRenderFns } from "./ExamTypeManagement.vue?vue&type=template&id=e0a142cc&scoped=true"
import script from "./ExamTypeManagement.vue?vue&type=script&lang=js"
export * from "./ExamTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./ExamTypeManagement.vue?vue&type=style&index=0&id=e0a142cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a142cc",
  null
  
)

export default component.exports